export default __webpack_public_path__ + "static/media/klemmrock-rockwool-komposition_comp.d65db881.jpg";